RivalIQ.module('extensions.jquery', function (module, App, Backbone, Marionette, $, _) {

    'use strict';

    /**
     * Creates an HTML tag with specified attributes.
     * @type {Function}
     */
    $.tagHtml = function (tag, attributes) {

        if (attributes && attributes.class && $.isArray(attributes.class)) {

            attributes.class = attributes.class.join(' ');
        }

        const el = $(`<${tag}/>`, attributes);

        return $('<div></div>').html(el).html();
    };

});
